import { Link } from 'react-router-dom';

const safetyItems = [
  'Verify website sources before using information',
  'Avoid clicking on suspicious or unknown links',
  'Protect your payment information at all times',
  'Review product details and descriptions carefully',
  'Use secure browsing practices and updated browsers',
];

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wide mb-4">
              Safety First
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-5">
              Is VigorBuy Spreadsheet Safe?
            </h2>
            <p className="text-foreground-500 leading-relaxed mb-6">
              Safety is an important part of online product research. Before using any product resource, users should
              verify information, check website authenticity, and protect personal data. Our safety guides explain how to
              identify trustworthy resources and avoid common online risks.
            </p>

            <ul className="space-y-3 mb-8">
              {safetyItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-primary-600 text-xs"></i>
                  </div>
                  <span className="text-sm text-foreground-600">{item}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/article/vigorbuy-spreadsheet-safety-guide"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Read VigorBuy Spreadsheet Safety Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20calm%20workspace%20with%20modern%20laptop%20on%20warm%20wooden%20desk%20beside%20small%20green%20succulent%20in%20ceramic%20pot%2C%20soft%20natural%20light%20from%20side%20window%2C%20clean%20organized%20serene%20aesthetic%2C%20peaceful%20secure%20atmosphere%2C%20warm%20neutral%20cream%20and%20sage%20tones%2C%20editorial%20photography%20with%20gentle%20diffused%20shadows&width=800&height=800&seq=safety-vb-v2&orientation=squarish"
                alt="VigorBuy Spreadsheet safety and security guide"
                title="VigorBuy Spreadsheet Safety Guide"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}